import UserRoleManagementContainer from "../../../Component/Application/userrole/user-role-management-container";   

const UserRoleManagementPage = () => {
    return (
        <div className="page-body">
            <UserRoleManagementContainer />

        </div>
    );
};

export default UserRoleManagementPage;